import React from 'react';

import * as styles from '../icons.css';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={60}
    viewBox="0 0 78 92"
    xmlSpace="preserve"
    focusable="false"
    fill="currentColor"
    className={styles.root}
  >
    <path
      fill="none"
      className={styles.stroke}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="m37.276 10.504 10.682 23.365 23.513.049-17.525 18.824 5.449 25.055-22.119-12.934-21.604 12.934 5.725-24.783L2.471 33.918l24.58-.049z"
    />
    <path
      className={[styles.stroke, styles.fill].join(' ')}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="m66.717 1.562.247 10.184 8.565 3.687-9.325 4.126-1.924 9.983-6.044-8.165-9.894 1.344 5.953-8.141-3.918-9.913 8.967 3.817z"
    />
    <ellipse className={styles.shadow} cx={36.75} cy={88.438} rx={17} ry={3} />
  </svg>
);
